
import Vue from 'vue'
import IntroRequestForm from '@/components/IntroRequestForm.vue'
export default Vue.extend({
 name:'IntroDrawer',components:{IntroRequestForm},props:{context:{type:Object,required:true}},
 data:()=>({previousFocus:null as HTMLElement|null,previousOverflow:''}),
 mounted(){this.previousFocus=document.activeElement as HTMLElement;this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';(this.$refs.dialog as HTMLElement).focus()},
 beforeDestroy(){document.body.style.overflow=this.previousOverflow;this.previousFocus?.focus()},
 methods:{keyboard(event:KeyboardEvent){
  if(event.key==='Escape'){event.preventDefault();this.$emit('close')}
  if(event.key!=='Tab')return;
  const nodes=Array.from((this.$refs.dialog as HTMLElement).querySelectorAll<HTMLElement>('button,a,input,textarea,[tabindex="0"]')).filter(node=>!node.hasAttribute('disabled')&&node.offsetParent!==null)
  if(!nodes.length){event.preventDefault();return}
  if(event.shiftKey&&document.activeElement===nodes[0]){event.preventDefault();nodes[nodes.length-1].focus()}
  else if(!event.shiftKey&&document.activeElement===nodes[nodes.length-1]){event.preventDefault();nodes[0].focus()}
 }}
})
